import { render, staticRenderFns } from "./descDrawer.vue?vue&type=template&id=ba99ea3e&scoped=true&"
import script from "./descDrawer.vue?vue&type=script&lang=js&"
export * from "./descDrawer.vue?vue&type=script&lang=js&"
import style0 from "./descDrawer.vue?vue&type=style&index=0&id=ba99ea3e&prod&lang=css&"
import style1 from "./descDrawer.vue?vue&type=style&index=1&id=ba99ea3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba99ea3e",
  null
  
)

export default component.exports